// extracted by mini-css-extract-plugin
export var root = "support-module--root--V++XD";
export var navContainer = "support-module--navContainer--crWQr";
export var content = "support-module--content--Tj2cD";
export var show = "support-module--show--M-0KU";
export var hide = "support-module--hide--jUztm";
export var pageContainer = "support-module--pageContainer--p8JFw";